module.exports = __webpack_public_path__ + "img/linemanwongnai.b99b55d7.jpg";